import { FileCategory, Folder, ProjectFile } from '@/types';

// Folders are backend entities (see `Folder` in src/types). Re-exported here so the
// existing tree components can keep importing from this module.
export type { Folder };

/**
 * Direct child folders of `parentId` within a single category, ordered the way
 * the backend intends: `sortOrder` ASC, then `createdAt` ASC as a stable tiebreak.
 */
export const getChildFolders = (
  folders: Folder[],
  category: FileCategory,
  parentId: string | null,
): Folder[] =>
  folders
    .filter(f => f.category === category && f.parentId === parentId)
    .sort((a, b) => {
      if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
      return (a.createdAt || '').localeCompare(b.createdAt || '');
    });

/** Files whose folder is exactly `folderId` (null => category root). */
export const getFilesInFolder = (
  files: ProjectFile[],
  folderId: string | null,
): ProjectFile[] =>
  files.filter(f => (f.folderId ?? null) === folderId);

/** Total files nested anywhere under `folderId` (for the count badge). */
export const countFilesUnder = (
  folders: Folder[],
  files: ProjectFile[],
  category: FileCategory,
  folderId: string,
): number => {
  let total = getFilesInFolder(files, folderId).length;
  for (const child of getChildFolders(folders, category, folderId)) {
    total += countFilesUnder(folders, files, category, child.id);
  }
  return total;
};
